var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommandsIconPrimary(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 86,
    viewBox: "0 0 101 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.6429 0.142838C46.2764 0.142838 35.3756 4.65813 27.3383 12.6954C19.301 20.7327 14.7857 31.6336 14.7857 43H0.5L19.0238 61.5238L19.3571 62.1905L38.5952 43H24.3095C24.3095 24.5714 39.2143 9.66665 57.6429 9.66665C76.0714 9.66665 90.9762 24.5714 90.9762 43C90.9762 61.4286 76.0714 76.3333 57.6429 76.3333C48.4524 76.3333 40.119 72.5714 34.119 66.5238L27.3571 73.2857C31.3258 77.2762 36.0452 80.4416 41.2432 82.5993C46.4411 84.7569 52.0149 85.8641 57.6429 85.8571C69.0093 85.8571 79.9102 81.3418 87.9474 73.3046C95.9847 65.2673 100.5 54.3664 100.5 43C100.5 31.6336 95.9847 20.7327 87.9474 12.6954C79.9102 4.65813 69.0093 0.142838 57.6429 0.142838ZM52.881 23.9524V47.7619L73.119 59.7619L76.7857 53.619L60.0238 43.6666V23.9524H52.881Z",
    fill: "#1D2939"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommandsIconPrimary);
export default __webpack_public_path__ + "static/media/Commands-icon-primary.54f0052576da743f56ad61fa6216d117.svg";
export { ForwardRef as ReactComponent };